import Vue from 'vue'
import Vuex from 'vuex'
import { teacherHomeApi } from '../utils/api'
Vue.use(Vuex)

// 全局单例存储

const store = new Vuex.Store({
    state: {
        isLogin: false, // process.env.isLogin
        user: getUser(),
        bigUser: {},
        navData: [],
        userMessage: {},
        subjectId: '',
        teachInfo: []
    },
    mutations: {
        login(state, user) {
            state.isLogin = (user !== null && user !== undefined)
            state.user = user
            let key = 'user'
            if (state.isLogin) {
                // 默认头像
                if (!user.face) {
                    user.face = 'images/head.png'
                }
                localStorage.setItem(key, JSON.stringify(user))
            } else {
                localStorage.removeItem(key)
            }
        },
        setBigUser(state, user) {
            state.bigUser = user
        },
        setSubjectId: function (state, subjectId) {
            state.subjectId = subjectId
            if (window.xkwTracker) {
                window.xkwTracker.$subject = subjectId
            }
        }
    },
    getters: {
        isTest: function () {
            return process.env.NODE_ENV !== 'production'
        },
        teachInfo: async function (state) {
            if (state.teachInfo.length === 0) {
                // 从缓存获取训练教师任教信息
                const res = await teacherHomeApi.getTeachInfo()
                for (let index = 0; index < res.body.length; index++) {
                    const element = res.body[index]
                    for (let cIndex = 0; cIndex < element.courses.length; cIndex++) {
                        const course = element.courses[cIndex]
                        course.fullName = element.stageName + course.courseName
                        if (!course.classes) {
                            course.classes = []
                        }
                    }
                }
                state.teachInfo = res.body
            }
            return state.teachInfo
        }
    }
})

function getUser() {
    let key = 'user'
    let localUser = null
    try {
        let user = localStorage.getItem(key)
        localUser = JSON.parse(user)
    } catch (e) {
        console.log(e)
    }
    return localUser
}

export default store

